import React, {useContext} from "react";
import {Typography, Block} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import "./style.scss";
//images
import ErrorImg from "../../images/errorImg";
// core
import {LayoutContext} from "../../../core/Contexts";

export default React.memo(function LotteryEmptyResult() {
    const contextLayout = useContext(LayoutContext);
    const {t} = useTranslation();

    return (
        <Block className="lottery-empty-result">
            <ErrorImg />
            <Typography
                as="div"
                className="title"
                size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 17}
            >
                {t("У вас пока нет ни одного номера участвующего в розыгрыше")}
            </Typography>
            <Typography
                as="div"
                className="text"
                size={_.gte(contextLayout?.width ?? 0, 768) ? 17 : 14}
            >
                {t("Включайте номера — выиграйте ценные призы от Безлимит!")}
            </Typography>
        </Block>
    );
});
